// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mvd0","select":"styles_select__10PLU"};